import api from "../api"

export const getDeviceUptime = async () => {
    try {
        const query = encodeURIComponent('network_probe_uptime_seconds')
        const { data } = await api.get(`mivulite/metrics/query_instant?query=${query}`)
        return data?.data?.result ?? []
    } catch (error) {
        console.error(error)
    }    
}



